import ContentNavigation from './ContentNavigation.vue';
export default {
  ContentNavigation,
};
